import { AdminPreferences, KendraConst, SearchInterface } from "@amzn/ask-legal-domain";
import { Select, SelectProps } from "@amzn/awsui-components-react";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";
import { withFirstPage } from "./search-filter-utils-v2";

const RELEVANCE = "RELEVANCE";
const SORTS: Record<string, { attribute: string; order: "ASC" | "DESC" }> = {
    CD_DESC: { attribute: KendraConst.ContainerIngestionKendraAttributes.Default.CreationDate, order: "DESC" },
    CD_ASC: { attribute: KendraConst.ContainerIngestionKendraAttributes.Default.CreationDate, order: "ASC" },
    UD_DESC: { attribute: KendraConst.ContainerIngestionKendraAttributes.Default.LastUpdatedDate, order: "DESC" },
    UD_ASC: { attribute: KendraConst.ContainerIngestionKendraAttributes.Default.LastUpdatedDate, order: "ASC" }
};

export const SortingV2 = (props: {
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    preferences?: AdminPreferences.SearchSorts;
    disabled?: boolean;
}) => {
    const options = React.useMemo<SelectProps.Option[]>(() => {
        const list: SelectProps.Option[] = [{ label: "Relevance", value: RELEVANCE }];
        if (props.preferences?.showCreatedDate) {
            list.push(
                { label: "Most recently created", value: "CD_DESC" },
                { label: "Least recently created", value: "CD_ASC" }
            );
        }
        if (props.preferences?.showUpdatedDate) {
            list.push(
                { label: "Most recently updated", value: "UD_DESC" },
                { label: "Least recently updated", value: "UD_ASC" }
            );
        }
        return list;
    }, [props.preferences]);

    // Selection comes from the query
    const sorting = props.queryInputState.value.sortingConfiguration;
    const selectedValue = Object.keys(SORTS).find(key =>
        SORTS[key].attribute === sorting?.attribute && SORTS[key].order === sorting?.order
    ) || RELEVANCE;
    const isOffered = options.some(o => o.value === selectedValue);
    const selectedOption = options.find(o => o.value === selectedValue) || options[0];

    // Defensive only: a sort can only enter the query through this control, which offers just the
    // preference-allowed options, so this never fires today. If a sort the preferences don't offer
    // ever does arrive (e.g. a future URL-restored query), it can't be seen or cleared from the
    // dropdown, so drop it the same way onChange would (back to page 1).
    React.useEffect(() => {
        if (!isOffered && sorting) {
            props.queryInputState.setValue(withFirstPage(
                SearchInterface.SearchQueryInput.removeSorting(props.queryInputState.value)
            ));
        }
    }, [isOffered, sorting]);

    const onChange = (value: string | undefined) => {
        const query = props.queryInputState.value;
        const sort = value ? SORTS[value] : undefined;
        props.queryInputState.setValue(withFirstPage(sort
            ? SearchInterface.SearchQueryInput.applySorting(query, sort)
            : SearchInterface.SearchQueryInput.removeSorting(query)
        ));
    };

    return (
        <Select
            inlineLabelText="Sort by"
            selectedOption={selectedOption}
            options={options}
            disabled={props.disabled}
            onChange={({ detail }) => onChange(detail.selectedOption.value)}
            selectedAriaLabel="Selected"
        />
    );
};
